import { Icon } from '..';

export const MenuIcon: Icon = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M3 18V16.3333H21V18H3ZM3 12.8333V11.1667H21V12.8333H3ZM3 7.66675V6H21V7.66675H3Z"
        fill={color}
      />
    </g>
  </svg>
);
